import { ObjectField, NoPointers, BooleanField, } from "@opendaw/lib-box";
export class AudioUnitUserInterface extends ObjectField {
    static create(construct) {
        return new AudioUnitUserInterface(construct);
    }
    constructor(construct) {
        super(construct);
    }
    get automationCollapsed() {
        return this.getField(1);
    }
    initializeFields() {
        return {
            1: BooleanField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "automationCollapsed",
                deprecated: false,
                pointerRules: NoPointers,
            }),
        };
    }
}
